
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Check if the user is on a mobile device
 */
export function isMobile(): boolean {
  // Server-side or no window available - return false as safe default
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // Check screen size first (most reliable)
  if (window.innerWidth < 768) {
    return true;
  }

  // Check for mobile user agent as secondary check
  const userAgent = navigator.userAgent;
  
  // Common mobile patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  
  return mobilePatterns.some((pattern) => userAgent.match(pattern));
}
